import { render } from "./crear_cuenta.vue?vue&type=template&id=722e9c26"
import script from "./crear_cuenta.vue?vue&type=script&lang=js"
export * from "./crear_cuenta.vue?vue&type=script&lang=js"

import "./crear_cuenta.vue?vue&type=style&index=0&id=722e9c26&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__